




























import { Getter, Mutation, namespace } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import Landing from '@/shared/views/Landing.vue';
import Signup from '@/shared/views/Signup.vue';
import { ApiService } from '@/shared/services/ApiService';
import { SignupData } from '@/shared/store/types';
import router from '@/router';

const economicModule = namespace('economic');

@Component({
  components: {
    Landing,
    Signup,
  },
})

export default class EconomicSignupProcess extends Vue {
  errors: object = {};

  submitting: boolean = false;

  importImmediately: boolean = false;

  @Getter('getStep') step!: number;

  @Mutation('setSignupData') setSignupData: any;

  @Mutation('nextStep') next: any;

  @Mutation('previousStep') previous: any;

  // Economic Module
  @economicModule.Mutation('setToken') setToken: any;

  // computed
  get token() {
    return this.$route.query.token;
  }

  async mounted() {
    if (!this.token) {
      window.location.href = 'https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appPublicToken=iZo9cAfMI4QgWouJGxhz5SwmQsgBbuVnIICvb8JBFxY1&redirectUrl=https%3A%2F%2Fsignup.clareply.com%2Fe-conomic';
      return;
    }

    this.setToken(this.token);

    await this.load();
  }

  private async load() {
    try {
      const response = await ApiService.get(`integration-api/v1/fetch/e-conomic/${this.token}`);

      const {
        data: { self },
      } = response.data;

      this.setSignupData({
        signupType: 'e-conomic',
        integrationData: {
          name: 'e-conomic',
          data: { token: this.token },
          loginLink: `${process.env.VUE_APP_AVO_URL}/?action=add-integration&action_args={"integrationName":"e-conomic","token":"${this.token}"}`,
        },
        orgName: self.company.name,
        orgCVR: self.company.companyIdentificationNumber,
        orgType: null,
        personName: self.user.name,
        personEmail: self.user.email,
        personPhone: self.company.phoneNumber,
        acceptedTermsAndAgreements: false,
        receiveNewsletters: false,
      });
    } catch (e) {
      await router.push({ path: '/' });
    }
  }

  async submit(data: SignupData) {
    const signupData = data;

    this.submitting = true;

    signupData.integrationData!.data.importImmediately = this.importImmediately;

    ApiService.post('signup-api/v1/signup', signupData)
      .then((response) => {
        const {
          data: {
            data: {
              redirect_url: redirectUrl,
            },
          },
        } = response;

        this.submitting = false;

        window.location.href = redirectUrl;
      })
      .catch(({ response }) => {
        this.submitting = false;

        if (response.status === 422) {
          this.errors = response.data;
        }
      });
  }
}
